import UpgradeTooltip from '@anm/components/UpgradeTooltip';
import { FC } from 'react';

import AccountList from './AccountList';
import { EmptyListMessage } from './Wrapper';
import getDestinationsByNetwork from './helpers/getDestinationsByNetwork';
import getFacebookDestinations from './helpers/getFacebookDestinations';
import getWebinarDestination from './helpers/getWebinarDestination';
import { FacebookDestinationsProps } from './types';

const DestinationAccountList: FC<FacebookDestinationsProps> = ({
  list,
  isEdit,
  errors,
  isWebinar,
  canShowWebinar,
  isWebinarEnabled,
  onWebinarChange,
  emptyListText,
  selectedIds = [],
  isScheduled,
  ...handlers
}) => {
  const [facebookPages, facebookGroups, facebookProfiles] = getFacebookDestinations(list, selectedIds);
  const youtubeDestinations = getDestinationsByNetwork(list, 'YOUTUBE', selectedIds);
  const rtmpDestinations = getDestinationsByNetwork(list, 'RTMP', selectedIds);
  const twitchDestinations = getDestinationsByNetwork(list, 'TWITCH', selectedIds);
  const linkedinDestinations = getDestinationsByNetwork(list, 'LINKEDIN', selectedIds);
  const igDestinations = getDestinationsByNetwork(list, 'INSTAGRAM', selectedIds);

  const isFbPageError = errors?.some(e => e.includes('FACEBOOK.page'));
  const isFbGroupError = errors?.some(e => e.includes('FACEBOOK.group'));
  const isFbProfileError = errors?.some(e => e.includes('FACEBOOK.profile'));
  const isYtError = errors?.some(e => e.includes('YOUTUBE'));
  const isLinkedinError = errors?.some(e => e.includes('LINKEDIN'));
  const isIGError = errors?.some(e => e.includes('INSTAGRAM'));

  const isEmptyList = list.length === 0;

  const tempFbWarning =
    isScheduled && isEdit
      ? "<div style='color: black; padding: 4px; background-color: var(--error_bkg); border-color: #f5c6cb;'>Re-scheduling on Facebook Groups will not delete old event. Please delete it manually.</div>"
      : '';

  return (
    <>
      {isEmptyList && <EmptyListMessage level={3} title={emptyListText} />}

      {canShowWebinar && (
        <UpgradeTooltip canShow={!isWebinarEnabled} text="Upgrade to premium plan to enable webinar">
          <AccountList
            list={[getWebinarDestination({ isChecked: isWebinar, isDisabled: !isWebinarEnabled })]}
            onSelectDestination={onWebinarChange}
          />
        </UpgradeTooltip>
      )}
      <AccountList title="Facebook pages" list={facebookPages} isError={isFbPageError} {...handlers} />
      <AccountList
        title="Facebook groups"
        subtitle={tempFbWarning}
        list={facebookGroups}
        isError={isFbGroupError}
        {...handlers}
      />
      <AccountList title="Facebook profiles" list={facebookProfiles} isError={isFbProfileError} {...handlers} />
      <AccountList title="YouTube channels" list={youtubeDestinations} isError={isYtError} {...handlers} />
      <AccountList title="Twitch channels" list={twitchDestinations} {...handlers} />
      <AccountList title="Instagram channels" list={igDestinations} isError={isIGError} {...handlers} />
      <AccountList
        title="LinkedIn channels"
        subtitle="Live chat comments on Linkedin are not available yet"
        list={linkedinDestinations}
        isError={isLinkedinError}
        {...handlers}
      />
      <AccountList title="Custom RTMPs" list={rtmpDestinations} {...handlers} onEdit={undefined} />
    </>
  );
};

export default DestinationAccountList;
